class ProductModal {
    constructor(modalSelector = '.custom-popup') {
        this.modal = document.querySelector(modalSelector);

        // If modal doesn't exist, create it dynamically
        if (!this.modal) {
            this.modal = document.createElement('div');
            this.modal.classList.add('custom-popup');
            document.body.appendChild(this.modal);
            this.content = document.createElement('div');
            this.content.classList.add('custom-popup-content');
            this.modal.appendChild(this.content);
        } else {
            this.content = this.modal.querySelector('.custom-popup-content');
        }

        this.closeBtn = null;

        this.modal.addEventListener('click', (e) => {
            if (e.target === this.modal) this.close();
        });

        // Automatically attach triggers
        this.attachTriggers();
    }

    attachTriggers() {
        document.querySelectorAll('[data-product-modal]').forEach(btn => {
            btn.addEventListener('click', () => {
                const handle = btn.dataset.handle;
                const shopCurrency = btn.dataset.shopCurrency;
                const moneyFormat = btn.dataset.moneyFormat;
                this.open(handle, shopCurrency, moneyFormat, btn);
            });
        });
    }

    async open(handle, shopCurrency, moneyFormat, btn) {
        const loader = window.createLoader(btn);
        loader.show();
        try {
            this.content.innerHTML = `<button class="custom-quick-view-popup-close" ><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18" stroke="#24574A" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6 6L18 18" stroke="#24574A" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`;
            this.closeBtn = this.content.querySelector('.custom-quick-view-popup-close');
            this.closeBtn.addEventListener('click', () => this.close());

            const html = await this.fetchProductHTML(handle);
            const section = html.querySelector('[id^="shopify-section-template"][id$="__template"]');

            if (!section) {
                console.error('Section not found on this product page');
                return;
            }

            this.content.appendChild(section.cloneNode(true));
            this.makePopupIdsUnique(this.content);
            this.modal.style.display = 'flex';
            document.body.classList.add('overflow-hidden');

            this.initPDPFeatures(this.content);

            const product = await this.fetchProductJSON(handle);
            this.initSwatchListeners(this.content, product, shopCurrency, moneyFormat);

            if (typeof trapFocus === 'function') trapFocus(this.modal, this.modal.querySelector('[role="dialog"]'));
            if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
            this.whichIsRightPopup();
            const buttons = document.querySelectorAll('.button-swatch .swatch_input');
            buttons.forEach(button => {
                button.disabled = false;
            });
        } catch (err) {
            console.error('Error loading product:', err);
            window.Toast.show('Failed to load product. Please try again.', 'error');
            loader.hide();
        } finally {
            loader.hide();
        }
    }
    makePopupIdsUnique(scope) {
        const uniquePrefix = 'popup-';

        // Update IDs and their corresponding label "for" attributes
        scope.querySelectorAll('input[data-hidden-input-field]').forEach(input => {
            const oldId = input.id;
            const newId = `${uniquePrefix}${oldId}`;
            input.id = newId;

            // Find and update only the matching label
            const label = scope.querySelector(`label[data-hidden-label-field][for="${oldId}"]`);
            if (label) {
                label.setAttribute('for', newId);
            }
        });

        // Update name attributes only for variant option inputs
        scope.querySelectorAll('.option-wrapper input[data-hidden-input-field]').forEach(input => {
            const oldName = input.name;
            input.name = `${uniquePrefix}${oldName}`;
        });
    }

    whichIsRightPopup() {
        const openPopup = document.querySelector('.open-popup');
        const popup = document.querySelector('.pdp-custom-popup');
        const closePopup = document.querySelector('.custom-popup-close');
        const overlay = document.querySelector('.custom-popup-overlay');

        if (openPopup && popup) {
            openPopup.addEventListener('click', (e) => {
                e.preventDefault();
                popup.style.display = 'flex';
            });

            [closePopup, overlay].forEach(el => {
                if (el) el.addEventListener('click', () => popup.style.display = 'none');
            });
        }
    }

    close() {
        this.modal.style.display = 'none';
        document.body.classList.remove('overflow-hidden');
        this.content.innerHTML = '';
    }

    async fetchProductHTML(handle) {
        const res = await fetch(`/products/${handle}`);
        const text = await res.text();
        return new DOMParser().parseFromString(text, 'text/html');
    }

    async fetchProductJSON(handle) {
        const res = await fetch(`/products/${handle}.js`);
        return res.json();
    }

    initPDPFeatures(scope) {

        const qtyInput = scope.querySelector('input[id$="qty"], input[name$="quantity"], #qty');
        const plusBtn = scope.querySelector('.plus-input');
        const minusBtn = scope.querySelector('.minus-input');

        if (qtyInput && plusBtn) plusBtn.addEventListener('click', () => qtyInput.value = Number(qtyInput.value) + 1); qtyInput.dispatchEvent(new Event('change'));
        if (qtyInput && minusBtn) minusBtn.addEventListener('click', () => {
            if (Number(qtyInput.value) > 1) qtyInput.value = Number(qtyInput.value) - 1; qtyInput.dispatchEvent(new Event('change'));
        });

        if (typeof Splide !== 'undefined') {
            const mainCarousel = scope.querySelector('#main-carousel');
            const thumbCarousel = scope.querySelector('#thumbnail-carousel');

            if (mainCarousel) new Splide(mainCarousel, { type: 'fade', pagination: false, arrows: false }).mount();
            if (thumbCarousel) new Splide(thumbCarousel, { fixedWidth: 80, fixedHeight: 80, isNavigation: true, gap: 10, focus: 'center', pagination: false, arrows: false }).mount();
        }
    }

    initSwatchListeners(scope, product, shopCurrency, moneyFormat) {
        scope.querySelectorAll('.option-wrapper input[type="radio"]').forEach(radio => {
            radio.addEventListener('change', () => {
                console.log("varinat change");
                const selectedOptions = Array.from(scope.querySelectorAll('.option-wrapper input[type="radio"]:checked')).map(r => r.value);
                const matchedVariant = product.variants.find(v => v.options.every((opt, i) => selectedOptions[i] === opt));
                if (!matchedVariant) return;

                const variantInput = scope.querySelector('#variantID');
                if (variantInput) variantInput.value = matchedVariant.id;

                const priceEl = scope.querySelector('.price');
                const compareEl = scope.querySelector('.price.strike');
                if (priceEl) priceEl.textContent = formatMoney(matchedVariant.price, shopCurrency).replace(/\.00$/, '');
                if (compareEl) {
                    compareEl.textContent = formatMoney(matchedVariant.compare_at_price, moneyFormat).replace(/\.00$/, '');
                    matchedVariant.compare_at_price > matchedVariant.price ? compareEl.classList.remove('hidden') : compareEl.classList.add('hidden');
                }

                const optionWrapper = radio.closest('.option-wrapper');
                const valueVariant = optionWrapper.querySelector('.legend .value-name');
                if (valueVariant) valueVariant.textContent = radio.value;

                const addBtn = scope.querySelector('#add-to-cart-text');
                if (addBtn) {
                    addBtn.textContent = matchedVariant.available ? 'ADD TO CART' : 'OUT OF STOCK';
                    addBtn.disabled = !matchedVariant.available;
                }
            });
        });
    }
}

// Auto-initialize modal
window.ProductModal = new ProductModal();